__turbopack_context__.v({
  "categoryTitle": "T-nwwq_categoryTitle",
  "content": "T-nwwq_content",
  "emptyStateButtonWrapper": "T-nwwq_emptyStateButtonWrapper",
  "emptyStateHeader": "T-nwwq_emptyStateHeader",
  "emptyStateWrapper": "T-nwwq_emptyStateWrapper",
  "listWrapper": "T-nwwq_listWrapper",
  "sortingInputWrapper": "T-nwwq_sortingInputWrapper",
  "sortingLabel": "T-nwwq_sortingLabel",
  "sortingWrapper": "T-nwwq_sortingWrapper",
  "title": "T-nwwq_title",
  "viewChangeWrapper": "T-nwwq_viewChangeWrapper",
  "viewTypeIconWrapperActive": "T-nwwq_viewTypeIconWrapperActive",
});
